//
// # Changes
//

export interface Child {
  id?: number;
  targetKind: string;
}

export type ChangeKind = "add" | "remove" | "update" | "unsupported";

export const ChangeKind = {
  Add: "add" as ChangeKind,
  Remove: "remove" as ChangeKind,
  Update: "update" as ChangeKind,
  Unsupported: "unsupported" as ChangeKind,
} as const;

// Change variants for a target type
export type Change<ChildType extends Child> =
  | ({ changeKind: "add" } & Data<ChildType>)
  | ({ changeKind: "remove" } & Data<Tag<ChildType>> & Ref)
  | ({ changeKind: "update" } & Data<Update<ChildType>> & Ref) // FIXME: probably just use the ID in the `ChildType`, maybe make it mandatory
  | ({ changeKind: "unsupported" } & { message: string }); // Unsupported or not implemented change
export const Change = { Kind: ChangeKind };

// type UpdateData = Data<Update<ChildType>>
export type Update<C extends Child> = Partial<C> &
  Pick<C, "targetKind"> &
  Pick<C, "id">; // "targetKind is mandatory, every other field of C is optional".
type Tag<T extends Child> = { targetKind: T["targetKind"] }; // Extract the `targetKind` field only
type Data<T> = { data: T }; // Data to be added or updated

// Reference to an existing object
type Ref = { id: number }; //| { uuid: Uuid } | { name: string };
